// Author Liang Gang Qiang
// Date 2022-03-14 16:19:42

class SithMesPrdToolsPackageItem {
constructor({
        id = null,
        packageId = '',
        packageName = '',
        toolsId = '',
        toolsName = '',
        quantity = '',
        type = '',
        status = '',
        seq = '',
        remark = ''}
= {}) {
    this.id = id;
    this.packageId = packageId;
    this.packageName = packageName;
    this.toolsId = toolsId;
    this.toolsName = toolsName;
    this.quantity = quantity;
    this.type = type;
    this.status = status;
    this.seq = seq;
    this.remark = remark;
}
}

function newEntity() {
return new SithMesPrdToolsPackageItem();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'packageName',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.grid.packageName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'toolsCode',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.grid.toolsCode',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'toolsName',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.grid.toolsName',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'toolsSize',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.grid.toolsSize',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'quantity',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.grid.quantity',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'pitchRow',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.grid.pitchRow',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'description',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.grid.description',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'specialDescription',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.grid.specialDescription',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'area',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.grid.area',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'bin',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.grid.bin',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'seq',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.grid.seq',
        sortable: true,
        form: {
        type: 'input',
        modalMultiSelectedType: 'string'
        }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
        }
        }
    ])}

const filter = {
    idFilter : '',
    idListFilter : [],
    packageIdFilter : '',
    packageNameFilter : '',
    toolsIdFilter : '',
    toolsNameFilter : '',
    quantityFilter : '',
    typeFilter : '',
    statusFilter : '',
    seqFilter : ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'packageNameFilter',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.filter.packageName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdToolsPackage'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"packageId":"id"}'
                }
        },
        {
        key: 'toolsNameFilter',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.filter.toolsName',
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdToolsInfo'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"toolsId":"id"}'
                }
        },
        {
        key: 'quantityFilter',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.filter.quantity',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'seqFilter',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.filter.seq',
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'packageName',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.entity.packageName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdToolsPackage'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"packageId":"id"}'
                }
        },
        {
        key: 'toolsName',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.entity.toolsName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect',
        modalMultiSelectedType: 'string'
            ,entity: 'sithMesPrdToolsInfo'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"toolsId":"id"}'
                }
        },
        {
        key: 'quantity',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.entity.quantity',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'seq',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.entity.seq',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber',
        modalMultiSelectedType: 'string'
                }
        },
        {
        key: 'remark',
        label: 'label.sith.prd.sithMesPrdToolsPackageItem.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea',
        modalMultiSelectedType: 'string'
                }
        }
]

export {SithMesPrdToolsPackageItem, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
